"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContentEditableFieldType;
(function (ContentEditableFieldType) {
    ContentEditableFieldType["Image"] = "Image";
    ContentEditableFieldType["Text"] = "Text";
    ContentEditableFieldType["WYSIWYG"] = "WYSIWYG";
    ContentEditableFieldType["Table"] = "Table";
})(ContentEditableFieldType = exports.ContentEditableFieldType || (exports.ContentEditableFieldType = {}));
//# sourceMappingURL=ContentEditableFieldType.js.map